import { isString } from "../utils/schemaUtils";

export interface LinearComment {
  id: string;
  author: string;
  body: string;
  createdAt: string;
  url: string;
}

const isLinearComment = (v: unknown): v is LinearComment => {
  if (!v || typeof v !== "object") return false;
  const r = v as Record<string, unknown>;
  return isString(r.id) && isString(r.author) && isString(r.body) && isString(r.createdAt) && isString(r.url);
};

export interface LinearCommentsPayload {
  type: "linear_comments";
  issueId: string;
  issueIdentifier: string;
  issueTitle: string;
  comments: LinearComment[];
}

export const parseLinearCommentsPayload = (v: unknown): LinearCommentsPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "linear_comments") return null;
  if (!isString(r.issueId)) return null;
  if (!isString(r.issueIdentifier)) return null;
  if (!isString(r.issueTitle)) return null;
  if (!Array.isArray(r.comments) || !r.comments.every(isLinearComment)) return null;
  return {
    type: "linear_comments",
    issueId: r.issueId,
    issueIdentifier: r.issueIdentifier,
    issueTitle: r.issueTitle,
    comments: r.comments,
  };
};
